import { Observable } from "rxjs";
import HttpService from "./HttpService"; 
import { url } from "./APIEndPoints";
import { buildParamString, IAPICommonResponse, IAPIResponse } from "@mindmemobile/mm-shared-global";
import { IAPICancelSubscriptionModel, IAPICreateSubscriptionAPIModel, IAPIEditSubscriptionAPIModel, IAPIPauseSubscriptionModel, IAPIResumeSubscriptionModel, IAPISubscriptionDetailPageModel, IAPISubscriptionGridModel } from "../interfaces/IAPISubscriptionModels";

class SubscriptionService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }
  getSubscriptions(
    accountId: string,
    pageNumber: number,
    pageSize: number,
    searchValue: string
  ): Observable<IAPIResponse<IAPISubscriptionGridModel[]>> {
    const params: string = buildParamString({
      accountId: accountId,
      pageNumber: pageNumber,
      pageSize: pageSize,
      searchValue: searchValue,
    });
    return this.httpService.get<IAPIResponse<IAPISubscriptionGridModel[]>>(
      url.subscriptions,
      params
    );
  }

  getSubscription(
    accountId: string,
    id: string,
    searchValue: string
  ): Observable<IAPIResponse<IAPISubscriptionDetailPageModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      id: id,
      searchValue: searchValue,
    });
    return this.httpService.get<IAPIResponse<IAPISubscriptionDetailPageModel>>(
      url.getSubscription,
      params
    );
  }

  createSubscription(
    data: IAPICreateSubscriptionAPIModel
  ): Observable<IAPIResponse<any>> {
    return this.httpService.post<IAPIResponse<any>>(
      url.createSubscription,
      data
    );
  }

  updateSubscription(
    data: IAPIEditSubscriptionAPIModel
  ): Observable<IAPIResponse<boolean>> {
    return this.httpService.put<IAPIResponse<boolean>>(
      url.updateSubscription,
      data
    );
  }

  cancelSubscription(
    data: IAPICancelSubscriptionModel
  ): Observable<IAPIResponse<IAPICommonResponse>> {
    return this.httpService.put<IAPIResponse<IAPICommonResponse>>(
      url.cancelSubscription,
      data
    );
  }

  pauseSubscription(
    data: IAPIPauseSubscriptionModel
  ): Observable<IAPIResponse<IAPICommonResponse>> {
    return this.httpService.put<IAPIResponse<IAPICommonResponse>>(
      url.pauseSubscription,
      data
    );
  }
  resumeSubscription(
    data: IAPIResumeSubscriptionModel
  ): Observable<IAPIResponse<IAPICommonResponse>> {
    return this.httpService.put<IAPIResponse<IAPICommonResponse>>(
      url.resumeSubscription,
      data
    );
  }
}
export default new SubscriptionService();
